// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_p5-5";
export var filledCircle = "_p5-4";
export var historyEntry = "_p5-3";
export var messageSideLeft = "_p5-1";
export var messageSideRight = "_p5-2";
export var orderTrackingCarouselWrapper = "_p5-6";
export var orderTrackingInfoContainer = "_p5-0";